import { render, staticRenderFns } from "./ReservationInfoDesktop.vue?vue&type=template&id=76a0557f&scoped=true&"
import script from "./ReservationInfoDesktop.vue?vue&type=script&lang=js&"
export * from "./ReservationInfoDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ReservationInfoDesktop.vue?vue&type=style&index=0&id=76a0557f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0557f",
  null
  
)

export default component.exports